import client from "./client";

export const getCasePage = () => client.post("/casepage/getPage");
export const addCasePage = (payload) => client.post("/casepage/addpage", payload);
export const updateCasePage = (payload) =>
  client.post("/casepage/updatePage", payload);
